import Error from "components/form/Error";
import InputArea from "components/form/InputArea";
import LabelArea from "components/form/LabelArea";
import Title from "components/form/Title";
import { FiX } from "react-icons/fi";
import useBillSubmit from "hooks/useBillSubmit";
import React from "react";
import Scrollbars from "react-custom-scrollbars-2";
import ActiveButton from "components/form/ActiveButton";
import Uploader from "components/image-uploader/Uploader";
import DrawerButton from "components/form/DrawerButton";
import { notifyError } from "utils/toast";
import { Textarea } from "@windmill/react-ui";

const PurchaseBillDrawer = ({ id, data = {}, tab }) => {
  const apiImageUrl = process.env.REACT_APP_API_IMAGE_URL || "defaultImageUrl";

  const {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    goToStep,
    step,
    errors,
    billImagesUrl1,
    setBillImagesUrl1,
    billImagesUrl2,
    setBillImagesUrl2,
    loading,
  } = useBillSubmit(data, data.va_id, data.bill_amount, data.bill_images);

  const handleFormSubmit = (data) => {
    const billImagesArray = [];

    if (billImagesUrl1) billImagesArray.push(billImagesUrl1);
    if (billImagesUrl2) billImagesArray.push(billImagesUrl2);

    if (billImagesArray.length === 0) {
      notifyError("Please upload at least one bill image.");
      return;
    }

    onSubmit({ ...data, bill_images: billImagesArray });
  };

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {tab > 0 ? <Title title={"Edit Bill"} /> : <Title title={"Add Bill"} />}
      </div>
      <div className="text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-400">
        <ul className="flex flex-wrap -mb-px">
          <li className="mr-2">
            <ActiveButton
              tabValue={1}
              labelName="Basic Details"
              goToStep={goToStep}
              step={step}
            />
          </li>
        </ul>
      </div>

      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit(handleFormSubmit)}>
          <div className="px-6 pt-8 scrollbar-hide flex-grow w-full h-full max-h-full pb-40 md:pb-32 lg:pb-32 xl:pb-32">
            {/* Bill Amount */}
            <div className="grid grid-cols-6 lg:grid-cols-12 gap-5">
              <div className="col-span-6">
                <LabelArea label="Bill Amount" required />
                <InputArea
                  trigger={trigger}
                  register={register}
                  label="Bill Amount"
                  name="bill_amount"
                  type="number"
                  placeholder="1000"
                  rules={{ required: "Bill Amount is required" }}
                />
                <Error errorName={errors.bill_amount} />
              </div>

              {/* <div className="col-span-6">
                <LabelArea label="Total KM" required />
                <InputArea
                  trigger={trigger}
                  register={register}
                  label="Total KM"
                  name="total_km"
                  type="number"
                  placeholder="333"
                  rules={{ required: "Total KM is required", min: 1 }}
                />
                <Error errorName={errors.total_km} />
              </div>

              <div className="col-span-6">
                <LabelArea label="Calculation" required />
                <InputArea
                  trigger={trigger}
                  register={register}
                  label="Calculation"
                  name="calculation"
                  type="text"
                  placeholder="Enter Calculation"
                  rules={{
                    required: "Calculation is required",
                    pattern: { value: /^\d+$/, message: "Must be numeric" },
                  }}
                />
                <Error errorName={errors.calculation} />
              </div> */}
             <div className="col-span-6">
              <LabelArea label="Remarks" />
              <Textarea
                {...register("remark")}
                name="remark"
                placeholder="Enter Remark"
              />
            </div>

              <div className="col-span-12">
                <LabelArea label="Bill Image 1" required />
                {billImagesUrl1 ? (
                  <>
                    <div className="flex items-center">
                      <img
                        style={{
                          objectFit: "cover",
                          width: "250px",
                          height: "100px",
                          borderRadius: "10px",
                        }}
                        src={apiImageUrl + billImagesUrl1}
                        alt="billImage1"
                      />
                      <FiX size={25} onClick={() => setBillImagesUrl1("")} />
                    </div>
                  </>
                ) : (
                  <Uploader
                    is_multiple={false}
                    folder="bills"
                    name_merge="bill_image1"
                    imageUrl={billImagesUrl1}
                    setImageUrl={setBillImagesUrl1}
                    no_of_image={1}
                  />
                )}
                <Error errorName={errors.bill_image1} />
              </div>

              <div className="col-span-12">
                <LabelArea label="Bill Image 2" />
                {billImagesUrl2 ? (
                  <>
                    <div className="flex items-center">
                      <img
                        style={{
                          objectFit: "cover",
                          width: "250px",
                          height: "100px",
                          borderRadius: "10px",
                        }}
                        src={apiImageUrl + billImagesUrl2}
                        alt="billImage2"
                      />
                      <FiX size={25} onClick={() => setBillImagesUrl2("")} />
                    </div>
                  </>
                ) : (
                  <Uploader
                    is_multiple={false}
                    folder="bills"
                    name_merge="bill_image2"
                    imageUrl={billImagesUrl2}
                    setImageUrl={setBillImagesUrl2}
                    no_of_image={1}
                  />
                )}
                <Error errorName={errors.bill_image2} />
              </div>
            </div>

            <DrawerButton
              isSubmitting={loading}
              id={id}
              title={id ? "Update" : "Submit"}
            />
          </div>
        </form>
      </Scrollbars>
    </>
  );
};

export default PurchaseBillDrawer;
